// Nastavení podle jazyka (hlavička a návratová URL do e-shopu). Ukládá se do obecného nastavení webu
// jako bannerI18n / returnUrlByLang; prázdná hodnota = použije se české nastavení (titulek přes slovník).
import { useEffect, useState, useSyncExternalStore } from 'react';
import { getLang } from './i18n';

// Výchozí logo hlavičky podle jazyka (převzato z konfigurátoru diářů); vlastní URL v administraci má přednost.
export const DEFAULT_LANG_LOGOS: Record<string, string> = { sk: '/logos/sk.png', pl: '/logos/pl.png' };

export type BannerTexts = { title?: string; subtitle?: string; logo?: string };
export type LangSettings = { bannerI18n: Record<string, BannerTexts>; returnUrlByLang: Record<string, string> };

let state: LangSettings = { bannerI18n: {}, returnUrlByLang: {} };
const subs = new Set<() => void>();
let saver: ((key: keyof LangSettings, value: any) => void) | null = null;

export const langSettings = {
  get: () => state,
  /** Načtení z Firestore (bez ukládání). */
  load(general: any) {
    state = {
      bannerI18n: general && typeof general.bannerI18n === 'object' && general.bannerI18n ? general.bannerI18n : {},
      returnUrlByLang: general && typeof general.returnUrlByLang === 'object' && general.returnUrlByLang ? general.returnUrlByLang : {},
    };
    subs.forEach(f => f());
  },
  setSaver(fn: typeof saver) { saver = fn; },
  /** Změna z administrace – uloží se hned (platí pro všechny zákazníky). */
  setBanner(lang: string, field: keyof BannerTexts, value: string) {
    const cur = { ...(state.bannerI18n[lang] || {}) };
    if (value) cur[field] = value; else delete cur[field];
    const next = { ...state.bannerI18n };
    if (Object.keys(cur).length) next[lang] = cur; else delete next[lang];
    state = { ...state, bannerI18n: next }; subs.forEach(f => f()); saver?.('bannerI18n', next);
  },
  setReturnUrl(lang: string, value: string) {
    const next = { ...state.returnUrlByLang };
    if (value) next[lang] = value; else delete next[lang];
    state = { ...state, returnUrlByLang: next }; subs.forEach(f => f()); saver?.('returnUrlByLang', next);
  },
  subscribe(f: () => void) { subs.add(f); return () => { subs.delete(f); }; },
};

export const useLangSettings = () => useSyncExternalStore(langSettings.subscribe, langSettings.get);

/** Aktuální jazyk zákaznické části (mění se i náhledem jazyka v administraci). */
export function useLang() {
  const [l, setL] = useState(getLang());
  useEffect(() => { const f = () => setL(getLang()); window.addEventListener('i18n:change', f); return () => window.removeEventListener('i18n:change', f); }, []);
  return l;
}
